import { useCurrency, shortPrice } from './shared'
import { t } from '../../../i18n'

// Japanese counter menu: washi off-white, thin type, a vermilion accent, and
// each category as a horizontal scroll-snap row of tall numbered cards -
// like sliding along a sushi counter.
export default function SushiTemplate({ menu, table, addItem, onSelectItem }) {
  const currency = useCurrency()
  const categories = menu.filter(c => c.items?.length)
  let counter = 0

  return (
    <div className="max-w-6xl mx-auto text-[#1f1f1f]" style={{ fontFamily: "'Hiragino Mincho ProN', 'Yu Mincho', Georgia, serif" }}>
      <header className="flex items-end justify-between border-b border-[#1f1f1f]/20 pb-6 mb-10">
        <div>
          <p className="text-[color:var(--brand,#c8402b)] text-sm tracking-[0.4em]">お品書き</p>
          <h1 className="text-4xl md:text-5xl font-light tracking-wide mt-2">{t("Omakase & à la carte")}</h1>
        </div>
        <div className="text-end">
          <span className="block w-12 h-12 rounded-full bg-[color:var(--brand,#c8402b)] ms-auto" aria-hidden="true" />
          {table && <p className="text-xs tracking-[0.3em] mt-2">{t("TABLE")} {table}</p>}
        </div>
      </header>

      {categories.map((c, ci) => (
        <section key={c.id} className="mb-14">
          <div className="flex items-baseline gap-4 mb-5">
            <span className="text-[color:var(--brand,#c8402b)] text-sm">{['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'][ci] || ci + 1}</span>
            <h2 className="text-2xl font-light tracking-[0.15em] uppercase">{c.name}</h2>
            <span className="flex-1 h-px bg-[#1f1f1f]/15" aria-hidden="true" />
            <span className="text-xs text-[#1f1f1f]/50">{t("scroll →")}</span>
          </div>
          <div className="flex gap-5 overflow-x-auto snap-x snap-mandatory no-scrollbar pb-2">
            {c.items.map(item => {
              counter += 1
              return (
                <article key={item.id} className="snap-start shrink-0 w-[200px] md:w-[230px]">
                  <button onClick={() => onSelectItem(item)} className="relative block w-full aspect-[3/4] bg-[#efeae0] overflow-hidden" aria-label={t("View {name}", { name: item.name })}>
                    {item.image && <img loading="lazy" src={item.image} alt={item.name} className="w-full h-full object-cover" onError={e => { e.currentTarget.style.display = 'none' }} />}
                    <span className="absolute top-3 start-3 bg-[#f7f4ee] text-[11px] px-2 py-0.5 tracking-widest">{String(counter).padStart(2, '0')}</span>
                  </button>
                  <div className="pt-3 flex justify-between gap-3">
                    <div className="min-w-0">
                      <h3 className="text-base leading-snug">{item.name}</h3>
                      {item.description && <p className="text-xs text-[#1f1f1f]/55 mt-1 line-clamp-2 font-sans">{t(item.description)}</p>}
                    </div>
                    <p className="text-sm whitespace-nowrap">{shortPrice(item.price)} <span className="text-[10px] text-[#1f1f1f]/50">{currency}</span></p>
                  </div>
                  <button onClick={() => addItem(item)} className="mt-3 w-full border border-[color:var(--brand,#c8402b)] text-[color:var(--brand,#c8402b)] text-xs tracking-[0.3em] py-2 hover:bg-[color:var(--brand,#c8402b)] hover:text-white transition-colors">{t("ADD")}</button>
                </article>
              )
            })}
          </div>
        </section>
      ))}
    </div>
  )
}
